import type { SystemFeaturesTablesProps } from '@/components/pricing/SystemFeaturesTables';
import SystemFeaturesTables from '@/components/pricing/SystemFeaturesTables';

const ALTER_SYSTEM_FEATURES: SystemFeaturesTablesProps = {
  features: [
    {
      title: 'Alter Signal Wearable',
      features: [
        {
          title: 'Sleep tracking (3 stage)',
          alterAnywhere: true,
          alterOne: true,
        },
        {
          title: 'Smart zone heart rate tracking',
          alterAnywhere: true,
          alterOne: true,
        },
        {
          title: 'Steps counter',
          alterAnywhere: true,
          alterOne: true,
        },
        {
          title: 'HRV stress monitoring',
          alterAnywhere: true,
          alterOne: true,
        },
        {
          title: 'Wrist, arm and bra clip',
          alterAnywhere: true,
          alterOne: true,
        },
      ],
    },
    {
      title: 'Alter Screen',
      features: [
        {
          title: 'On-screen workouts',
          alterAnywhere: false,
          alterOne: true,
        },
        {
          title: 'Fitness assessment tracking',
          alterAnywhere: false,
          alterOne: true,
        },
        {
          title: '3D body composition scanning',
          alterAnywhere: false,
          alterOne: true,
        },
      ],
    },
    {
      title: 'Alter App',
      features: [
        {
          title: 'Daily personalized fitness plan',
          alterAnywhere: true,
          alterOne: true,
        },
        {
          title: 'Fitness goal tracking',
          alterAnywhere: true,
          alterOne: true,
        },
        {
          title: 'DNA test results and traits',
          alterAnywhere: true,
          alterOne: true,
        },
        {
          title: 'Workout & meditation library',
          alterAnywhere: true,
          alterOne: true,
        },
        {
          title: 'Personalized nutrition plan',
          alterAnywhere: true,
          alterOne: true,
        },
        {
          title: '1:1 personalized coaching',
          alterAnywhere: true,
          alterOne: true,
        },
        {
          title: 'Membership included*',
          alterAnywhere: '12 Months',
          alterOne: '24 Months',
        },
      ],
    },
  ],
};

const PricingWhatsIncludedSection = () => {
  return <SystemFeaturesTables features={ALTER_SYSTEM_FEATURES.features} />;
};

export default PricingWhatsIncludedSection;
